import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material";
import { ShipStatusEnum } from '../../../enums/ship-status-enum';
import { ShipTypeEnum } from '../../../enums/ship-type-enum';

@Component({
    selector: 'dialog-show-status',
    templateUrl: './dialog-show-status.component.html',
    styleUrls: ['./dialog-show-status.component.scss']
})

export class DialogShowStatusComponent implements OnInit {

  statusEnum: ShipStatusEnum;
  type = ShipTypeEnum;

  status = ['DELIVERY_DRIVER.LABELS.STATUS_SHIP.LOADED', 'DELIVERY_DRIVER.LABELS.STATUS_SHIP.TRANSIT',
    'DELIVERY_DRIVER.LABELS.STATUS_SHIP.ARRIVED', 'DELIVERY_DRIVER.LABELS.STATUS_SHIP.ABSENT_CLIENT', 'DELIVERY_DRIVER.LABELS.STATUS_SHIP.DELIVERED',
  'DELIVERY_DRIVER.LABELS.STATUS_SHIP.RECOLECTED'];

  statusToShow: any[] = [];

  typeShip: any;
  selectedStatus: any;


  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private dialogRef: MatDialogRef<DialogShowStatusComponent>) {
   
  }

  statusF() {
    return Object.values(ShipStatusEnum);
  }

  ngOnInit(): void {
    this.typeShip = this.data;
    if (this.typeShip == this.type.DEVOLUTION) {
      this.statusToShow.push('DELIVERY_DRIVER.LABELS.STATUS_SHIP.ABSENT_CLIENT');
      this.statusToShow.push('DELIVERY_DRIVER.LABELS.STATUS_SHIP.RECOLECTED');
    } else {
      this.statusToShow.push('DELIVERY_DRIVER.LABELS.STATUS_SHIP.ABSENT_CLIENT');
      this.statusToShow.push('DELIVERY_DRIVER.LABELS.STATUS_SHIP.DELIVERED');
    }
  }

  cambiarStatus() {
    let statusToReturn;
    if (this.selectedStatus) {
      this.status.forEach((item, index) => {
        if (this.selectedStatus == item) {
          statusToReturn = index;
          return;
        }
      });
      this.dialogRef.close(statusToReturn);
    }
  }
}
